import React, { useState } from 'react';
import { Button, Message } from '@arco-design/web-react';
import { useNavigate } from 'react-router-dom';
import AutoWidthInput from '../Common/AutoWidthInput';
import { PlatformIcon } from './AnalysisComponents';
import { startAnalysisApi, stopAnalysisApi, getTaskIdAnalysisResultApi } from '../../Api/api';

export default function FilterBar({ 
  inputValue, 
  setInputValue, 
  currentTask,
  onTaskUpdate // 新增回调函数用于更新任务状态
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  // 事件处理函数（可根据实际需求传递props或调用API）
  const handleGoToPrivateMessage = () => {
    if (currentTask) {
  
      // 跳转到PrivateCustomer页面，并传递任务ID参数
      navigate('/private-customer', { 
        state: { 
          selectedTaskId: currentTask.task_id,
          selectedPlatform: currentTask.platform 
        } 
      });
    }
  };

  const handleDownloadResult = async () => {
    if (!currentTask) return;
    
    try {
      const response = await getTaskIdAnalysisResultApi(currentTask.task_id);
      if (response && response.status === 200) {
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([JSON.stringify(response.data)]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `analysis_result_${currentTask.task_id}.json`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        Message.success('下载成功');
      } else {
        Message.error('下载失败，请稍后重试');
      }
    } catch (error) {
      console.error('下载结果失败:', error);
      Message.error('下载失败，请稍后重试');
    }
  };

  const handleStartAnalysis = async () => {
    if (!currentTask) return;
    
    setLoading(true);
    try {
      const response = await startAnalysisApi({
        comment_id: null,
        task_id: currentTask.task_id,
        platform: currentTask.platform,
        analysis_request: "背景：我们的服务介绍是：我是代理记账服务方\n我想要的客户描述：需要代理记账服务的企业，尤其是中小微企业，这些企业可能没有足够的财务专业人员或资源来处理复杂的财务事务，希望将记账等财务工作外包以降低成本、提高效率、确保财务合规性，同时希望代理记账服务方能提供准确、及时的财务报表和税务申报等服务。\n你要分析抖音以及小红书平台上关于《代理记账》搜索后呈现相关内容下方的评论，内容都是跟关键词对应相关的\n你的任务：\n1. 分析关键词背后对应的产品、服务、行业\n2. 判断后面提供的评论是否是对这个关键词对应的营销视频/笔记内容感兴趣的客户\n3. 对这个客户进行评级：\n高意向：想了解我们的服务价格、或想学习、合作、加盟、购买以及对产品/服务有疑问或比较纠结的潜在客户\n低意向：需求不确定、对产品/服务无意向或批评的客户、提供同样产品/服务的同行，直接意向判定为无意向",
        output_fields: [
          {
            key: "意向客户",
            explanation: "用户是否为有明确意向了解/购买代理记账这个产品/服务的高意向客户（有明确意向填是，其他都填否)"
          },
          {
            key: "分析理由",
            explanation: "20字内简要说明这么分析的理由"
          }
        ]
      });
      
      if (response && (response.status === 200 || response.msg === 'success')) {
        Message.success('分析已开始');
        console.log('分析启动成功，返回的任务ID:', response.data?.task_id);
        // 通知父组件更新任务状态
        if (onTaskUpdate) {
          onTaskUpdate();
        }
      } else {
        console.error('分析启动失败，响应:', response);
        Message.error('开始分析失败：' + (response?.msg || '未知错误'));
      }
    } catch (error) {
      console.error('开始分析失败:', error);
      Message.error('开始分析失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleStopAnalysis = async () => {
    if (!currentTask) return;
    
    setLoading(true);
    try {
      const response = await stopAnalysisApi({
        task_id: currentTask.task_id
      });
      
      if (response && (response.status === 200 || response.msg === 'success')) {
        Message.success('分析已停止');
        console.log('分析停止成功，响应:', response.data);
        // 通知父组件更新任务状态
        if (onTaskUpdate) {
          onTaskUpdate();
        }
      } else {
        console.error('分析停止失败，响应:', response);
        Message.error('停止分析失败：' + (response?.msg || '未知错误'));
      }
    } catch (error) {
      console.error('停止分析失败:', error);
      Message.error('停止分析失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  // 动态渲染按钮
  let actionButton = null;
  if (currentTask) {
    if (currentTask.analysis_state === 'finish') {
      actionButton = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button type="primary" style={{ marginLeft: 8 }} onClick={handleGoToPrivateMessage}>
            前往私信
          </Button>
          <span 
            style={{ 
              marginLeft: 10, 
              color: '#165DFF', 
              cursor: 'pointer',
              fontSize: '14px'
            }} 
            onClick={handleDownloadResult}
          >
            下载结果
          </span>
        </div>
      );
    } else if (currentTask.analysis_state === 'initial') {
      actionButton = (
        <Button 
          type="primary" 
          style={{ marginLeft: 8 }} 
          onClick={handleStartAnalysis}
          loading={loading}
        >
          开始分析
        </Button>
      );
    } else if (currentTask.analysis_state === 'running') {
      actionButton = (
        <Button 
          type="primary" 
          style={{ marginLeft: 8 }} 
          onClick={handleStopAnalysis}
          loading={loading}
        >
          停止分析
        </Button>
      );
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14, marginTop: -9, marginLeft: -3 }}>
      <span style={{
        fontSize: 20,
        fontWeight: 600,
        marginRight: 18,
        marginLeft: 6,
        display: 'flex',
        alignItems: 'center'
      }}>
        {currentTask ? (
          <>
            <PlatformIcon
              platform={currentTask.platform}
              style={{
                fontSize: 20,
                width: 24,
                height: 24,
                marginRight: 20,
                verticalAlign: 'middle'
              }}
            />
            {typeof currentTask.intent_count === 'number' && (
              <span style={{ marginLeft: 10, color: 'black', fontSize: 20 }}>
                {currentTask.keyword}
                {currentTask.intent_count}个意向
              </span>
            )}
          </>
        ) : (
          '请选择任务'
        )}
      </span>
      <AutoWidthInput
        addBefore="我的产品/服务/品牌是"
        value={inputValue}
        onChange={setInputValue}
        placeholder={currentTask ? currentTask.keyword : '请输入关键词'}
      />
      {/* 动态按钮 */}
      {actionButton}
    </div>
  );
}